
import type { SampleConfigurationTypeKey } from "./SampleConfigurationType.ts";
import type { ProcessingTypeKey } from "./ProcessingType.ts";

// Generated from io.spcfy.orders.persistence.SequencingPlatform

export type SequencingPlatformKey =
  "ILLUMINA" |
  "ONT";


export interface SequencingPlatformDTO {
  key: SequencingPlatformKey;
  label: string;
  isPairedEnd: boolean;
  allowedSampleConfigurations?: SampleConfigurationTypeKey[];
  allowedProcessingTypes?: ProcessingTypeKey[];    
}


export const SequencingPlatforms: Record<SequencingPlatformKey, SequencingPlatformDTO> = {
  ILLUMINA: { key: "ILLUMINA", label: "Illumina", isPairedEnd: true },
  ONT: { key: "ONT", label: "Nanopore (ONT)", isPairedEnd: false, allowedSampleConfigurations: ["MERGED_SAMPLES", "MERGED_AND_TRIMMED_SAMPLES"], allowedProcessingTypes: ["METABARCODING"] }
};
